import Component from '../core/Component'
import { queries } from '../core/config'
import Flickity from 'flickity'
import enquire from 'enquire.js'
import { CMS } from '../core/config'
import Scroll from '../services/Scroll'

export const EMITS = {
    LINK_CLICKED: 'linkClicked'
}

export default class Menu extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            links: []
        }

        this.menuFlickity = null
        this.canTransformToFlickity = true

        this.enquireHandler = null

        if (this.options.disableFlickity) {
            this.enquireQuery = this.options.disableFlickity in queries ? queries[this.options.disableFlickity] : this.options.disableFlickity
            this.enquireHandler = {
                match: () => this.match(),
                unmatch: () => this.unmatch()
            }
        }
    }

    prepare() {
        if (CMS) {
            return
        }

        this.ref.links.forEach(link => link.addEventListener('click', this.handleLinkClick))

        this.check()

        if (this.enquireHandler) {
            enquire.register(this.enquireQuery, this.enquireHandler)
        }

        Scroll.on('resize-x', this.handleResize)
    }

    destroy() {
        if (this.enquireHandler) {
            enquire.unregister(this.enquireQuery, this.enquireHandler)
        }

        Scroll.off('resize-x', this.handleResize)
    }

    handleResize = () => {
        this.check()
    }

    handleLinkClick = event => {
        event.preventDefault() //@TODO: doresit propisovani hashe a historii swupu
        const element = event.currentTarget
        const index = this.ref.links.indexOf(element)

        this.emit(EMITS.LINK_CLICKED, {
            index
        })
    }

    match() {
        if (this.menuFlickity) {
            this.menuFlickity.destroy()
            this.menuFlickity = null
        }
        this.canTransformToFlickity = false
    }

    unmatch() {
        this.canTransformToFlickity = true
    }

    check() {
        if (this.menuFlickity || !this.canTransformToFlickity) {
            return
        }

        if (this.element.offsetWidth < this.element.scrollWidth) {
            this.menuFlickity = new Flickity(this.element, {
                cellAlign: 'center',
                prevNextButtons: false,
                pageDots: false,
                contain: true
            })
        }
    }

    getLinks() {
        return this.ref.links
    }

    getActiveLinkIndex() {
        return this.ref.links.findIndex(link => link.classList.contains('is-active'))
    }

    select(index) {
        this.ref.links.forEach(link => link.classList.remove('is-active'))
        this.ref.links[index].classList.add('is-active')

        this.menuFlickity?.select(index)
    }
}